import React from "react";

function Timing({ width = 20, height = 20, fill = "#C7A600" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8335 2.5C6.69183 2.5 3.3335 5.85833 3.3335 10H0.833496L4.07516 13.2417L4.1335 13.3583L7.50016 10H5.00016C5.00016 6.775 7.6085 4.16667 10.8335 4.16667C14.0585 4.16667 16.6668 6.775 16.6668 10C16.6668 13.225 14.0585 15.8333 10.8335 15.8333C9.22516 15.8333 7.76683 15.175 6.71683 14.1167L5.5335 15.3C6.89183 16.6583 8.7585 17.5 10.8335 17.5C14.9752 17.5 18.3335 14.1417 18.3335 10C18.3335 5.85833 14.9752 2.5 10.8335 2.5ZM10.0002 6.66667V10.8333L13.5668 12.95L14.1668 11.9417L11.2502 10.2083V6.66667H10.0002Z"
        fill={fill}
      />
    </svg>
  );
}

export default Timing;
